import { AvailableModules, Features } from 'generated/featureDefinitions'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

export const isValidModule = (value: string | null | undefined): value is AvailableModules => {
  if (!value) return false
  return Object.values(AvailableModules).some((enumValue) => enumValue === value)
}

export const isValidReason = (value: string | null | undefined): value is ValidReasons => {
  if (!value) return false
  return Object.values(ValidReasons).some((enumValue) => enumValue === value)
}

export const isValidFeature = (value: string | null | undefined): value is Features => {
  if (!value) return false
  return Object.values(Features).some((enumValue) => enumValue === value)
}
